import React from "react";
import PropTypes from "prop-types";

const Message = ({ msg, additionalStyles = "", closable = true }) => {
  return (
    <div className={`alert alert-info alert-dismissible fade show ${additionalStyles}`} role="alert">
      {msg}
      {closable && (
      <button
        type="button"
        className="close"
        data-dismiss="alert"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      )}
    </div>
  );
};

Message.propTypes = {
  msg: PropTypes.string.isRequired,
};

export default Message;
